import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchSites } from '../../../api/statisticsApi';

const useFetchSites = () => {
    const [siteOptions, setSiteOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchSites().then((data) => {
            const options = data.length > 0
                ? data.map((site) => ({
                    label: site.siteName,
                    value: site.siteId
                }))
                : [];
            setSiteOptions(options);
            setLoading(false);
        })
            .catch((err) => {
                toast.error("Cannot Fetch Site Options", err);
                setLoading(false);
            });
    }, []);

    return { siteOptions, loading };
};

export default useFetchSites;